import {
  importUpdateNominaInProcessNeeded,
  importUpdateNominaProccesedNeeded,
} from 'src/redux/actions/proveedores';

/** Refresca listas de nóminas en Proveedores tras conciliación que puede afectar imputación bancaria. */
export function dispatchRefreshNominaLists(dispatch) {
  dispatch(importUpdateNominaInProcessNeeded({ value: true }));
  dispatch(importUpdateNominaProccesedNeeded({ value: true }));
}
